import React from 'react';
import { useSubscriptionContext } from './subscription.provider';

export interface Props {
    titles: string[];
}

const StepIcon = ({ index, currentIndex }: { index: number; currentIndex: number }): JSX.Element => {
    if (index === currentIndex) {
        return <div className="steps__header__step__icon-active" />;
    } else if (index < currentIndex) {
        return <div className="steps__header__step__icon-done" />;
    } else {
        return <div className="steps__header__step__icon-inactive" />;
    }
};


export const StepsHeader = (props: Props): JSX.Element => {
    const { currentIndex} = useSubscriptionContext();

    return (
        <div className="steps__header">
            {props.titles.map((it, index) => (
                <div key={index} className="steps__header__step">
                    <span
                        className={`steps__header__step__title ${index <= currentIndex ? 'steps__header__step__title--active' : ''}`}
                    >
                        {it.toUpperCase()}
                    </span>
                    <div className="steps__header__step__icon-container">
                        <StepIcon index={index} currentIndex={currentIndex} />
                        {index < props.titles.length - 1 && (
                            <div
                                className={`steps__header__step__line ${
                                    index < currentIndex ? 'steps__header__step__line--active' : ''
                                }`}
                            />
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};